import { Locales } from '../../../localization/locales';

export default {
  [Locales.ru]: {
    yes: 'Да',
    no: 'Нет',
  },
  [Locales.en]: {
    yes: 'Yes',
    no: 'No',
  }
}
